import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { HorizontalLineInterface } from 'common/types/entities/HorizontalLineInterface'
import { BorderStyleEnum, BorderTypeEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createHorizontalLine(
  parentId: string,
  masterBlockId?: MasterBlockId,
): HorizontalLineInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.HorizontalLine,
      parentId,
      masterBlockId,
    ),
    border: {
      width: 1,
      style: BorderStyleEnum.solid,
      radius: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
      },
      color: 'rgba(68, 68, 68, 1)',
      type: BorderTypeEnum.fullBorder,
    },
  }
}
